import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

const FullScreenLoader = ({ open, text = "Please wait..." }) => {
  if (!open) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        backdropFilter: "blur(6px)",
        backgroundColor: "rgba(0, 0, 0, 0.35)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        zIndex: 9999,
      }}
    >
      <CircularProgress
        size={70}
        thickness={5}
        sx={{ color: "#2e7d32" }}
      />

      <Typography
        sx={{
          mt: 3,
          color: "#ffffff",
          fontWeight: 500,
          fontSize: "16px",
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default FullScreenLoader;